var _path, _path2, _path3, _path4, _path5, _path6;
import * as React from "react";
var SvgDmaeIconinline = function SvgDmaeIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7961aa",
    d: "M16.085 26.955v4.755l13.605-7.855V8.16l-4.115 2.365V21.48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3f3f3",
    d: "M16.085.29 2.48 8.145v.015l4.12 2.365 9.485-5.48 9.49 5.48L29.69 8.16v-.015z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#503795",
    d: "M16.085 26.955v4.755L2.48 23.855V8.16l4.115 2.365V21.48z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7961aa",
    d: "M16.085 8.335V5.01L6.57 10.505v10.98l2.88-1.655v-7.66z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3f3f3",
    d: "m22.725 19.83-6.64 3.835L9.45 19.83l-2.88 1.655v.01l9.515 5.495 9.52-5.495v-.01z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#503795",
    d: "M16.085 8.335V5.01l9.515 5.495v10.98l-2.875-1.655v-7.66z"
  })));
};
export default SvgDmaeIconinline;